import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M7.35 14c0-.58.47-1.05 1.05-1.05 5.43 0 9.437 1.085 13.225 2.139l.226.063C25.55 16.18 29.034 17.15 33.6 17.15a1.05 1.05 0 1 1 0 2.1c-4.856 0-8.578-1.036-12.253-2.059l-.285-.08c-3.763-1.046-7.536-2.06-12.662-2.06-.58 0-1.05-.47-1.05-1.05Z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M34.65 7c0-.58-.47-1.05-1.05-1.05-3.129 0-5.432.708-7.612 2.142-2.094 1.377-4.054 3.42-6.51 5.978l-.076.078C14.55 19.203 10.618 19.95 8.4 19.95a1.05 1.05 0 0 0 0 2.1c2.822 0 7.29-1.003 12.518-6.448 2.548-2.654 4.35-4.522 6.224-5.756 1.81-1.19 3.707-1.796 6.458-1.796.58 0 1.05-.47 1.05-1.05"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLine;
